import React from "react";
import { Col, Row } from "react-bootstrap";
import ReactHtmlParser from "react-html-parser";
import NumberFormat from "react-number-format";
import { Link } from "react-router-dom";

import { Mixpanel } from "../../../../../../actions/mixpanel.actions";
import { formatDateSmallWithoutTimezone } from "../../../../../../utils/dates";

import styles from "./ProjectDetail.scss";

class ProjectDetail extends React.Component {
  getSuffix(type) {
    if (!type) return "";
    switch (type.toUpperCase()) {
      case "HOURLY":
        return "/hour";
      case "DAILY":
        return "/day";
      case "WEEKLY":
        return "/week";
      case "MONTHLY":
        return "/month";
      default:
        return "";
    }
  }

  render() {
    const { projectData } = this.props;

    const skillsMapper = (skill, index) => (
      <li key={index}>{skill.description.name}</li>
    );

    const mustSkillsList =
      !_.isEmpty(projectData.must_skills) &&
      projectData.must_skills.map(skillsMapper);

    const mustSkillsListComponent = (
      <ul className={styles.list}>{mustSkillsList}</ul>
    );

    const niceSkillsList =
      !_.isEmpty(projectData.nice_skills) &&
      projectData.nice_skills.map(skillsMapper);

    const niceSkillsListComponent = (
      <ul className={styles.list}>{niceSkillsList}</ul>
    );

    const NA = <div className={styles.naStyle}>N/A</div>;
    const bullet = <span className={styles.bullet}>&#9679;</span>;

    const formattedBudgetStart =
      formatDateSmallWithoutTimezone(projectData.budget_run_start) ==
      "Invalid date"
        ? "N/A"
        : formatDateSmallWithoutTimezone(projectData.budget_run_start);

    const formattedBudgetEnd =
      formatDateSmallWithoutTimezone(projectData.budget_run_end) ==
      "Invalid date"
        ? "N/A"
        : formatDateSmallWithoutTimezone(projectData.budget_run_end);

    let city = projectData.state
      ? `${projectData.city}, ${projectData.state}`
      : projectData.city;

    //remove 'USA' if the city string includes it
    if (projectData.city && projectData.city.includes(", USA")) {
      city = projectData.city.replace(", USA", "");
    }

    let budgetRate = parseFloat(projectData.budget_rate_value);

    const budgetRateValue =
      _.get(projectData, "budget_type.value") === "Negotiable" ? (
        "Request from Member"
      ) : (
        <NumberFormat
          value={budgetRate}
          displayType={"text"}
          thousandSeparator={true}
          prefix={"$"}
          decimalScale={2}
        />
      );

    const dateField = () => {
      if (projectData.budget_run_start && projectData.budget_run_end) {
        return `${formattedBudgetStart} - ${formattedBudgetEnd}`;
      } else if (!projectData.budget_run_start && !projectData.budget_run_end) {
        return "Timing TBD";
      } else {
        if (projectData.budget_run_start) {
          return "Start Date: " + formattedBudgetStart;
        } else if (projectData.budget_run_end) {
          return "Project Due: " + formattedBudgetEnd;
        }
      }
    };

    const company = _.get(projectData, "user.profile.company");

    return (
      <div className={styles.projectDetail}>
        <Row>
          <Col className={styles.header}>
            <h1>{projectData.title}</h1>
            <Link
              className={styles.companyTitle}
              to={`/member/company/${_.get(company, "id")}`}
            >
              {_.get(company, "name")}
            </Link>
            <Link
              className={styles.companyDetailLink}
              to={`/member/company/${_.get(company, "id")}`}
              onClick={() =>
                Mixpanel.track("Member - Project Detail - Company Details")
              }
            >
              Company details ›
            </Link>
            &nbsp;
          </Col>
        </Row>

        <Row>
          <div className={styles.divider} />
          <div className={styles.divider} />
        </Row>

        <Row className={styles.sectionHeader}>
          <h2 className={styles.headerText}>Summary</h2>
        </Row>
        <Row>
          <div className={styles.whiteSectionRound}>
            {_.get(projectData, "category.name")}
            {bullet}
            {city}
            {bullet}
            {dateField()}
            {bullet}
            {_.get(projectData, "budget_type.value") === "Negotiable" ? (
              "Request Fee from Member"
            ) : (
              <NumberFormat
                value={budgetRate}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
                decimalScale={2}
                suffix={this.getSuffix(_.get(projectData, "budget_type.value"))}
              />
            )}
          </div>
        </Row>

        <Row className={styles.sectionHeader}>
          <h2 className={styles.headerText}>Job Description</h2>
          &nbsp;
        </Row>
        <Row>
          <div className={styles.whiteSectionRound}>
            <h3 className={styles.subSectionHeader}>Overview</h3>
            <div>{ReactHtmlParser(projectData.overview)}</div>
            &nbsp;
            <div className={styles.divider} />
            <h3 className={styles.subSectionHeader}>
              Responsibilities + Deliverables
            </h3>
            <div>{ReactHtmlParser(projectData.responsibilities)}</div>
            &nbsp;
            <div className={styles.divider} />
            <h3 className={styles.subSectionHeader}>Office location</h3>
            <div>{city}</div>
            &nbsp;
            <div className={styles.divider} />
            <h3 className={styles.subSectionHeader}>Work from</h3>
            <div>{_.get(projectData, "work_type.value")}</div>
            &nbsp;
            <div className={styles.divider} />
            <h3 className={styles.subSectionHeader}>Job Type</h3>
            <div>
              <p>{_.get(projectData, "job_type.value")}</p>
            </div>
          </div>
        </Row>

        <Row className={styles.sectionHeader}>
          <h2 className={styles.headerText}>Budget</h2>
        </Row>
        <Row className={styles.whiteSectionRound}>
          <Col xs={4}>
            <h3 className={styles.subSectionHeader}>Rate type</h3>
            <p>{_.get(projectData, "budget_type.value")}</p>
          </Col>
          <Col xs={4}>
            <h3 className={styles.subSectionHeader}>Rate</h3>
            <p>{budgetRateValue}</p>
          </Col>
          <Col xs={4}>
            <h3 className={styles.subSectionHeader}>Hours per Week</h3>
            <p>{projectData.budget_rate_period}</p>
          </Col>
        </Row>

        <Row className={styles.sectionHeader}>
          <h2 className={styles.headerText}>Project Run</h2>
        </Row>
        <Row className={styles.whiteSectionRound}>
          <Col xs={4}>
            <h3 className={styles.subSectionHeader}>Start</h3>
            <p>{formattedBudgetStart ? formattedBudgetStart : NA}</p>
          </Col>
          <Col xs={4}>
            <h3 className={styles.subSectionHeader}>End</h3>
            <p>{formattedBudgetEnd ? formattedBudgetEnd : NA}</p>
          </Col>
        </Row>

        <Row className={styles.sectionHeader}>
          <h2 className={styles.headerText}>Skills</h2>
        </Row>
        <Row>
          <div className={styles.whiteSectionRound}>
            <div className={styles.skillsListContainer}>
              <h3 className={styles.subSectionHeader}>Must have skills</h3>
              {_.isEmpty(mustSkillsList) ? NA : mustSkillsListComponent}
            </div>

            <div className={styles.divider} />

            <div className={styles.skillsListContainer}>
              <h3 className={styles.subSectionHeader}>Nice-to-Have Skills</h3>
              {_.isEmpty(niceSkillsList) ? NA : niceSkillsListComponent}
            </div>
          </div>
        </Row>
      </div>
    );
  }
}

export default ProjectDetail;



// WEBPACK FOOTER //
// ./src/routes/candidate/project/detail/components/ProjectDetail/ProjectDetail.js